import React, { useCallback, useState } from 'react'
import FullQuestionView from './FullQuestionView'
import QuestionItem from './QuestionItem'
import QuestionModal from './QuestionModal';

function ListQuestions(props) {


  const [overlay, setOverlay] = useState(null);


  const RenderItems = useCallback(
    () => {
      return props.data && props.data.map((n) => {
        return (
          <QuestionItem
            checked={n.question_id === overlay?.question_id}
            openFullView={() => {
              props.onClick();
              setOverlay(n);
              console.log("fullview opened", n)
            }}
            questionData={n}
            key={n?.question_id}
          />)

      }, this)
    },
    [props.data, overlay],
  )

  let dataArray = props.data.find((item) => { return item.question_id === overlay?.question_id })
 
 
 
 
  return (
    <>  <RenderItems />
{console.log('dataArray',dataArray)}

      
        <QuestionModal
        open={overlay && !!dataArray}
       onClose={() => { props.onClick(); setOverlay(null); console.log("fullview closed") }}
         questionData={dataArray}


        />
        
        

    </>
  )
}

export default ListQuestions